import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

function Edit(props) {
  console.log(props.value);

  const history = useNavigate();

  const [file, setFile] = useState(null);
  const [inputVal, setInputValue] = useState({
    imgpath:"",
    frontendpath:"",
    fname: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setInputValue((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res3 = await fetch(`https://pratik-agro-backend.vercel.app/getImg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data1 = await res3.json();

    if (res3.status === 422 || !data1) {
      console.log("error");
    } else {
      console.log(data1);
    setInputValue({
      imgpath: data1.imgpath,
      frontendpath:data1.frontendpath,
      fname: data1.fname,
      date: data1.date,
    });
  }
  };
  useEffect(() => {
    getData();
  },[]);

  const updateData = async (e) => {
    e.preventDefault();

    console.log(inputVal);

    var formData = new FormData();
    if (file != null) {
      formData.append("image", file);
    }
    formData.append("fname", inputVal.fname);
    formData.append("date", inputVal.date);
    formData.append("frontendpath", inputVal.frontendpath);
    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/update/${id}`, formData, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/Home");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <>
      <div className="content ">
        <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/Home">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
         
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Select Carousel img:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image"
              onChange={(e) => setFile(e.target.files[0])}
              value={inputVal.image}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Carousel image Name :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname"
              required
              onChange={setData}
              value={inputVal.fname}
             
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Products Description :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="frontendpath"
              onChange={setData}
              value={inputVal.frontendpath}
              disabled
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              required
              onChange={setData}
              value={inputVal.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData}>
              update Detail
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}
export default Edit;
